const View = require("presto-ui").baseView;
const dom = require("presto-ui").doms;

const LinearLayout = require("presto-ui").views.LinearLayout;
const ImageView = require("presto-ui").views.ImageView;
const TextView = require("presto-ui").views.TextView;

const Config = require('./../../globalConfig');
const Controller = require('./../../controller/pages/Main/Home');
const Strings = require('./../../res/string');
const Accessibility = require('./../../res/accessibility');
const Font = require('./../../res/fontStyle');
const Color = require('./../../res/color');
const FontSize = require('./../../res/fontSize');
const FontColor = require('./../../res/fontColor');

class Home extends Controller {

	constructor(props, children, state) {
		super(props, children, state);
		this.STR = Strings();
		this.HINT = Accessibility();
	}

	onPop = () => {}

	render = () => {
		this.layout = (
			<LinearLayout
				id={this.id("Content")}
				height="match_parent"
				width="match_parent"
				orientation="vertical"
				gravity="center_horizontal"
				background={Color.A__FFFFFFFF}
				cornerRadius="0"
				root={true}
				style={this.style_Content}>
				<LinearLayout
					id={this.id("Content100000000ø")}
					height="100"
					width="match_parent"
					orientation="horizontal"
					padding="80,25,80,24"
					cornerRadius="0"
					style={this.style_Content100000000ø}>
					<LinearLayout
						id={this.id("Group_3")}
						height="36"
						width="300"
						orientation="horizontal"
						margin="0,7,0,0"
						style={this.style_Group_3}>
						<LinearLayout
							id={this.id("Juspay_Logo_V3")}
							height="34"
							width="153"
							orientation="horizontal"
							gravity="center"
							weight="1"
							style={this.style_Juspay_Logo_V3}>
							<ImageView
								id={this.id("Juspay_Logo_V3200000000ø")}
								height="34"
								width="match_parent"
								imageUrl="juspay_logo_v32"
								style={this.style_Juspay_Logo_V3200000000ø} />
						</LinearLayout>
						<ImageView
							id={this.id("University")}
							height="31"
							width="143"
							margin="4,5,0,0"
							imageUrl="university1"
							style={this.style_University} />
					</LinearLayout>
					<LinearLayout
						id={this.id("Space")}
						weight="1"
						style={this.style_Space} />
					<LinearLayout
						id={this.id("Group_2")}
						height="50"
						width="380"
						orientation="horizontal"
						style={this.style_Group_2}>
						<TextView
							id={this.id("Register")}
							height="25"
							width="67"
							margin="0,13,0,0"
							text={this.STR.Register1}
							textSize={FontSize.A_18}
							color={FontColor.A__FF3A3A3A}
							fontStyle={Font.AVENIR_ROMAN}
							gravity="left"
							style={this.style_Register} />
						<TextView
							id={this.id("Forum")}
							height="25"
							width="53"
							margin="50,13,0,0"
							text={this.STR.Forum2}
							textSize={FontSize.A_18}
							color={FontColor.A__FF3A3A3A}
							fontStyle={Font.AVENIR_ROMAN}
							gravity="left"
							style={this.style_Forum} />
						<LinearLayout
							id={this.id("Group")}
							height="50"
							width="160"
							orientation="vertical"
							padding="33,13,0,12"
							margin="50,0,0,0"
							weight="1"
							background={Color.A__FFFF0000}
							cornerRadius="4"
							style={this.style_Group}>
							<TextView
								id={this.id("Get_Started")}
								height="25"
								width="95"
								text={this.STR.Get_Started3}
								textSize={FontSize.A_18}
								color={FontColor.A__FFFFFFFF}
								fontStyle={Font.AVENIR_ROMAN}
								gravity="left"
								style={this.style_Get_Started} />
						</LinearLayout>
					</LinearLayout>
				</LinearLayout>
				<LinearLayout
					id={this.id("BgHerotextHe")}
					height="700"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					padding="80,30,80,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_BgHerotextHe}>
					<LinearLayout
						id={this.id("Landing")}
						height="606"
						width="match_parent"
						orientation="horizontal"
						style={this.style_Landing}>
						<LinearLayout
							id={this.id("HerotextHero")}
							height="606"
							width="660"
							orientation="vertical"
							padding="0,40,0,0"
							weight="1"
							cornerRadius="0"
							style={this.style_HerotextHero}>
							<ImageView
								id={this.id("Hero")}
								height="255"
								width="445"
								margin="88,0,0,0"
								imageUrl="hero3"
								style={this.style_Hero} />
							<LinearLayout
								id={this.id("Space500000000ø")}
								weight="1"
								style={this.style_Space500000000ø} />
							<LinearLayout
								id={this.id("Hero_text")}
								height="237"
								width="match_parent"
								orientation="vertical"
								gravity="center_horizontal"
								cornerRadius="0"
								style={this.style_Hero_text}>
								<TextView
									id={this.id("Build_real_products")}
									height="142"
									width="match_parent"
									text={this.STR.Build_real_products4}
									textSize={FontSize.A_60}
									color={FontColor.A__FFFF0000}
									fontStyle={Font.AVENIR_BLACK}
									lineHeight="71px"
									gravity="left"
									style={this.style_Build_real_products} />
								<TextView
									id={this.id("In_the_process_of_cr")}
									height="80"
									width="match_parent"
									margin="0,15,0,0"
									text={this.STR.In_the_process_of_cr5}
									textSize={FontSize.A_18}
									color={FontColor.A__FF4A494A}
									fontStyle={Font.AVENIR_BOOK}
									lineHeight="28px"
									gravity="left"
									style={this.style_In_the_process_of_cr} />
							</LinearLayout>
						</LinearLayout>
						<LinearLayout
							id={this.id("Group300000000ø")}
							height="606"
							width="350"
							orientation="vertical"
							margin="110,0,0,0"
							cornerRadius="0"
							style={this.style_Group300000000ø}>
							<TextView
								id={this.id("Story_of_1B_txns")}
								height="50"
								width="match_parent"
								text={this.STR.Story_of_1B_txns6}
								textSize={FontSize.A_40}
								color={FontColor.A__FF000000}
								fontStyle={Font.AVENIR_BLACK}
								lineHeight="42px"
								gravity="left"
								style={this.style_Story_of_1B_txns} />
							<TextView
								id={this.id("Our_engineering_adva")}
								height="50"
								width="match_parent"
								margin="0,5,0,0"
								text={this.STR.Our_engineering_adva7}
								textSize={FontSize.A_16}
								color={FontColor.A__FF4A494A}
								fontStyle={Font.AVENIR_ROMAN}
								lineHeight="24px"
								gravity="left"
								style={this.style_Our_engineering_adva} />
							<TextView
								id={this.id("Know_how")}
								height="25"
								width="95"
								margin="0,20,0,0"
								text={this.STR.Know_how8}
								textSize={FontSize.A_18}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_Know_how} />
							<LinearLayout
								id={this.id("Line")}
								height="3"
								width="match_parent"
								background={Color.A__FFD7D7D7}
								stroke="3,#ff0000"
								margin="0,36,0,0"
								cornerRadius="0"
								style={this.style_Line} />
							<TextView
								id={this.id("School_of_FP")}
								height="50"
								width="match_parent"
								margin="0,40,0,0"
								text={this.STR.School_of_FP9}
								textSize={FontSize.A_40}
								color={FontColor.A__FF000000}
								fontStyle={Font.AVENIR_BLACK}
								lineHeight="42px"
								gravity="left"
								style={this.style_School_of_FP} />
							<TextView
								id={this.id("Breaking_the_myth_th")}
								height="50"
								width="match_parent"
								margin="0,5,0,0"
								text={this.STR.Breaking_the_myth_th10}
								textSize={FontSize.A_16}
								color={FontColor.A__FF4A494A}
								fontStyle={Font.AVENIR_ROMAN}
								lineHeight="24px"
								gravity="left"
								style={this.style_Breaking_the_myth_th} />
							<TextView
								id={this.id("Link")}
								height="25"
								width="105"
								margin="0,20,0,0"
								text={this.STR.Get_Started3}
								textSize={FontSize.A_18}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_Link} />
							<LinearLayout
								id={this.id("Line400000000ø")}
								height="3"
								width="match_parent"
								background={Color.A__FFD7D7D7}
								stroke="3,#ff0000"
								margin="0,34,0,0"
								cornerRadius="0"
								style={this.style_Line400000000ø} />
							<TextView
								id={this.id("Foundation")}
								height="50"
								width="match_parent"
								margin="0,40,0,0"
								text={this.STR.Foundation11}
								textSize={FontSize.A_40}
								color={FontColor.A__FF000000}
								fontStyle={Font.AVENIR_BLACK}
								lineHeight="42px"
								gravity="left"
								style={this.style_Foundation} />
							<TextView
								id={this.id("Derived_from_the_mat")}
								height="50"
								width="match_parent"
								margin="0,5,0,0"
								text={this.STR.Derived_from_the_mat12}
								textSize={FontSize.A_16}
								color={FontColor.A__FF4A494A}
								fontStyle={Font.AVENIR_ROMAN}
								lineHeight="24px"
								gravity="left"
								style={this.style_Derived_from_the_mat} />
							<TextView
								id={this.id("Coming_soon")}
								height="25"
								width="120"
								margin="0,20,0,0"
								text={this.STR.Coming_soon13}
								textSize={FontSize.A_18}
								color={FontColor.A__FF000000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_Coming_soon} />
						</LinearLayout>
					</LinearLayout>
					<LinearLayout
						id={this.id("Rectangle")}
						height="20"
						width="964"
						background={Color.A__FFFFFFFF}
						margin="0,44,0,0"
						cornerRadius="0"
						style={this.style_Rectangle} />
				</LinearLayout>
			</LinearLayout>
		);
		this.containerId = this.layout.idSet.id;
		return this.layout.render();
	}

};

module.exports = Home;



// WEBPACK FOOTER //
// ./views/Main/Home.js